import { Layout, Button, Card, Steps, Form, Dialog, Loading, Notification, Select, Switch, Tooltip, Cascader, Checkbox } from 'element-react';
import { useEffect, useState, useRef, } from 'react';
import { Auth, API, graphqlOperation } from 'aws-amplify';
import { createCompany, updateCompany } from '../graphql/mutations';
import { getCompany, listCategorys } from '../graphql/queries';
import { useTranslation } from 'react-i18next';
import userStore from '../store/user';
import { useHistory, useParams } from "react-router-dom";
import { addCompanyRulesMinus1, addCompanyRules0, addCompanyRules1, addCompanyRules2 } from '../utils/AddCompanyRules';
import tooltopImage from '../assets/imgs/tooltip.png';
import { mexStates, usaStates, canadaStates } from '../utils/Catalogs'
import * as companyLambdaInvokes from '../graphql/companyLambdaInvokes';
import WizardNgStepMinus1 from '../components/company/wizardNgStepMinus1';
import WizardNgStep0 from '../components/company/wizardNgStep0';
import WizardNgStep1 from '../components/company/wizardNgStep1';
import WizardNgStep2 from '../components/company/wizardNgStep2';
import MyStoreCropImage from './MyStoreCropImage';
import { IA_CHAT_ASSISTANT_URL } from '../utils/Constants';
import * as LogType from '../utils/LogType';
import logInDB from '../graphql/logLambdaInvokes';

function MyStoreWizard() {
    let history = useHistory();
    let { id, paramStep } = useParams();
    const { user } = userStore();
    const [options2, setOptions2] = useState([]);
    const [imageDialogVisible, setImageDialogVisible] = useState(false);
    const [fieldToUpdate, setFieldToUpdate] = useState('');
    const [iaModalDialogVisible, setIaModalDialogVisible] = useState(false);
    let [countryOptions, setCountryOptions] = useState({
        options: []
    });
    let type = {
        options: [
            {
                label: 'Manufacturer',
                value: 'Manufacturer'
            },
            {
                label: 'Trading Company',
                value: 'Trading Company'
            }
        ]
    }
    let main_market = {
        options: [
            {
                label: 'Canada',
                value: 'Canada'
            },
            {
                label: 'México',
                value: 'México'
            },
            {
                label: 'USA',
                value: 'USA'
            }
        ]
    }
    let revenue = {
        options: [
            {
                label: '<50,000 USD',
                value: '<50,000 USD'
            },
            {
                label: '50,000-100,000 USD',
                value: '50,000-100,000 USD'
            },
            {
                label: '500,000-2,500,000 USD',
                value: '500,000-2,500,000 USD'
            },
            {
                label: '>2,500,000 USD',
                value: '>2,500,000 USD'
            }
        ]
    }

    let [yearOptions, setYearOptions] = useState({
        options: []
    });
    const formMinus1 = useRef(null);
    const form0 = useRef(null);
    const form1 = useRef(null);
    const form2 = useRef(null);
    const [loading, setLoading] = useState(false);
    const [formInputs, setFormInputs] = useState(
        {
            name: '',
            type: '',
            age: '',
            anual_revenue: '',
            description: '',
            region: '',
            featured_category: '',
            file1: null,
            urlFile1: null,
            file2: null,
            urlFile2: null,
            titles: '',
            employees_qty: '',
            production_lines_qty: '',
            additional_titles1: '',
            additional_titles2: '',
            additional_titles3: '',
            additional_titles5: '',
            file1Name: '',
            main_market: '',
            allow_custom_product: '',
            address_str: '',
            street: '',
            street2: '',
            city: '',
            state: '',
            country: '',
            zipCode: '',
            phone: '',

            condition1: false,
            condition2: false,
            condition3: false,

            website: '',

            promote1: '',
            promote2: '',
            promote3: '',
            process1: '',
            process2: '',
            process3: '',

            about_market1: '',
            about_market2: '',
            about_market3: '',
            about_market4: '',
            about_market5: '',
            cover_picture: null,
            company_logo: null,
            ia_description: ''
        }
    )
    const [currentStep, setCurrentStep] = useState(-1);
    const { t, i18n } = useTranslation();
    const [rulesMinus1, setRulesMinus1] = useState(null);
    const [rules0, setRules0] = useState(null);
    const [rules1, setRules1] = useState(null);
    const [rules2, setRules2] = useState(null);
    useEffect(() => {
        console.log('MyStore');
        console.log('user country :: ' + user.country);
        if (user.country === 'MEX') {
            setCountryOptions(mexStates);
        } else {
            if (user.country === 'USA') {
                setCountryOptions(usaStates);
            } {
                if (user.country === 'CAN') {
                    setCountryOptions(canadaStates);
                }
            }
        }

        (async () => {
            try {
                const result = await API.graphql({ query: listCategorys });
                console.log({ result });
                const newData = [];
                const _listCatgorys = result.data.listCategorys.items;
                _listCatgorys.sort(compare);
                _listCatgorys.forEach((element, index) => {
                    console.log(element);
                    const parent = {
                        label: element.name,
                        value: element.id,
                        children: []
                    }
                    const _tags = element.tags;
                    _tags.sort(compareTags)
                    _tags.forEach(child => {
                        const _child =
                        {
                            value: child,
                            label: child
                        }
                        parent.children.push(_child);
                    });

                    newData.push(parent);
                });
                setOptions2(newData);
            } catch (e) {
                console.error(e);
            }
        })();

        setRulesMinus1(addCompanyRulesMinus1(t));
        setRules0(addCompanyRules0(t));
        setRules1(addCompanyRules1(t));
        setRules2(addCompanyRules2(t));
        fillYearsOptions();

        if (id != '0') {
            if (paramStep != '0') {
                setCurrentStep(parseInt(paramStep));
            } else {
                logInDB({ message: 'creating company', type: LogType.INIT_CREATE_COMPANY_TYPE, user: user != null && user.name != null ? user.name : 'anonymous' });
                setCurrentStep(0);
            }
            getCompanyData();
        }

    }, [user.country])

    useEffect(() => {
        const unblock = history.block((location, action) => {
            console.log('action :: ' + action + ' location :: ' + location.pathname);
            
            // Si navegamos fuera del wizard (excluyendo la pantalla final 'f' y el mismo wizard) mostramos advertencia
            if ((action == 'POP' || action == 'PUSH') 
                && location.pathname != '/my-store/f'
                && !location.pathname.startsWith('/my-store-wizard-ng/')) {
                
                return window.confirm(`
                    Are you sure you want to exit your Company wizard?

                    This will erase all your changes.
                `);
            } else {
                return true;
            }

        });

        return () => {
            unblock();
        };
    }, [])

    function compare(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
        }
        return 0;
    }

    function compareTags(a, b) {
        if (a.toLowerCase() < b.toLowerCase()) {
            return -1;
        }
        if (a.toLowerCase() > b.toLowerCase()) {
            return 1;
        }
        return 0;
    }

    const idenfityDescriptionLanguage = async () => {
        const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();
        const response = await fetch(IA_CHAT_ASSISTANT_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(
                {
                    model: 'gpt-4o-mini',
                    messages: [
                        {
                            role: 'system',
                            content: "response only 'true' or 'false' if the next text is in spanish: " + formInputs.description
                        }
                    ]
                })
        });
        const data = await response.json();
        console.log(data);
        if (data.response === 'true') {
            setLoading(true);
            setIaModalDialogVisible(true);
            await getIADescription();
            setLoading(false);
        }
    }

    const copyIADescriptionToDescription = () => {
        setFormInputs({ ...formInputs, description: formInputs.ia_description });
    }

    const getIADescription = async () => {
        try {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();
            const response = await fetch(IA_CHAT_ASSISTANT_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                body: JSON.stringify({
                    model: 'gpt-4o-mini',
                    messages: [
                        {
                            role: 'system',
                            content: "You are a translation assistant. Only translate the given text to english, do not explain or add extra information ==> " + formInputs.description
                        }
                    ]
                })
            });
            const data = await response.json();
            console.log(data);
            setFormInputs({ ...formInputs, ia_description: data.response });
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    const getCompanyData = async () => {
        setLoading(true);
        console.log('looking for store id :: ' + id);
        try {
            const input = {
                id: id
            }
            const result = await API.graphql(graphqlOperation(getCompany, input));
            console.log({ result })
            const _companyData = result.data.getCompany;
            const _featured_category = _companyData.featured_category.split('|');
            setFormInputs({
                name: _companyData.name,
                type: _companyData.type,
                age: _companyData.age,
                anual_revenue: _companyData.anual_revenue,
                description: _companyData.description,
                region: _companyData.region,
                featured_category: _featured_category != '' && _featured_category != null && _featured_category.length == 2 ? [_featured_category[0], _featured_category[1]] : [],
                file1: null,
                urlFile1: null,
                file2: null,
                urlFile2: null,
                titles: _companyData.titles,
                employees_qty: _companyData.employees_qty,
                production_lines_qty: _companyData.production_lines_qty,
                additional_titles1: _companyData.additional_titles1,
                additional_titles2: _companyData.additional_titles2,
                additional_titles3: _companyData.additional_titles3,
                additional_titles4: _companyData.additional_titles4,
                file1Name: '',
                main_market: _companyData.main_market,
                allow_custom_product: _companyData.allow_custom_product == 1 ? true : false,
                address_str: _companyData.address_str,
                street: _companyData.address?.street,
                city: _companyData.address?.city,
                zipCode: _companyData.address?.zipCode,
                state: _companyData.address?.state,
                country: _companyData.address?.country,
                phone: _companyData.address?.phone,
                website: _companyData.website,
                street2: _companyData.address_line2,

                promote1: _companyData.promote1,
                promote2: _companyData.promote2,
                promote3: _companyData.promote3,
                process1: _companyData.process1,
                process2: _companyData.process2,
                process3: _companyData.process3,

                about_market1: _companyData.about_market1,
                about_market2: _companyData.about_market2,
                about_market3: _companyData.about_market3,
                about_market4: _companyData.about_market4,
                about_market5: _companyData.about_market5,

                cover_picture: _companyData.cover_picture,
                company_logo: _companyData.company_logo,
                published: _companyData.published,
            })

        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }

    }

    const nextStep = async () => {
        console.log('currentStep :: ' + currentStep);
        console.log('next step');
        //go to top of the form smoothly
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (currentStep == 0) {
            form0.current.validate((valid) => {
                console.log('validator :: ' + valid);
                if (valid) {
                    setCurrentStep(currentStep + 1);
                } else {
                    console.log('invalid form');
                }
            });
        } else {
            if (currentStep == 1) {
                //TODO descomentar y validar
                form1.current.validate(async (valid) => {
                    console.log('validator :: ' + valid);
                    if (valid) {
                        if (id != '0') {
                            await updateStoreData();
                            //setCurrentStep(currentStep + 1);
                        } else {
                            saveMyStore();
                        }
                    } else {
                        console.log('invalid form');
                    }
                });
            } else {
                setCurrentStep(currentStep + 1);
            }
        }
    }

    const prevStep = () => {
        setCurrentStep(currentStep - 1);
    }

    const editCompanyImage = (field) => {
        console.log("editCompanyImage: ", field)
        setImageDialogVisible(true);
        setFieldToUpdate(field);
    }

    const updateStoreData = async () => {
        setLoading(true);
        try {
            const user = await Auth.currentAuthenticatedUser();
            console.log("formInputs.allow_custom_product :: " + formInputs.allow_custom_product);
            const input = {
                id: id,
                name: formInputs.name,
                type: formInputs.type,
                age: formInputs.age,
                anual_revenue: formInputs.anual_revenue,
                region: formInputs.region,
                featured_category: formInputs.featured_category != null && formInputs.featured_category.length == 2 ? formInputs.featured_category[0] + '|' + formInputs.featured_category[1] : [],
                additional_titles1: formInputs.additional_titles1,
                additional_titles2: formInputs.additional_titles2,
                additional_titles3: formInputs.additional_titles3,
                additional_titles4: formInputs.additional_titles4,
                description: formInputs.description,
                main_market: formInputs.main_market,
                allow_custom_product: formInputs.allow_custom_product == true ? 1 : 0,
                titles: formInputs.titles,
                production_lines_qty: formInputs.production_lines_qty,
                employees_qty: formInputs.employees_qty,
                address_str: formInputs.address_str,
                address: {
                    street: formInputs.street,
                    city: formInputs.city,
                    zipCode: formInputs.zipCode,
                    phone: formInputs.phone,
                    state: formInputs.state,
                    country: formInputs.country
                },
                website: formInputs.website,
                address_line2: formInputs.street2,

                promote1: formInputs.promote1,
                promote2: formInputs.promote2,
                promote3: formInputs.promote3,
                process1: formInputs.process1,
                process2: formInputs.process2,
                process3: formInputs.process3,
                about_market1: formInputs.about_market1,
                about_market2: formInputs.about_market2,
                about_market3: formInputs.about_market3,
                about_market4: formInputs.about_market4,
                about_market5: formInputs.about_market5

            };
            const result = await API.graphql(
                graphqlOperation(updateCompany, { input })
            );
            console.log("Created company", result);
            await companyLambdaInvokes.updateCompanyData({
                id: id,
                name: formInputs.name,
            })
            setLoading(false);
            history.push("/my-store-wizard-ng/" + id + "/2");
            setCurrentStep(2);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (e) {
            console.error(e)
            setLoading(false);
            if (e === 'The user is not authenticated') {
                history.push("/");
            }
        }
    }

    const saveMyStore = async () => {
        if (id != '0') {
            updateStoreData();
        } else {
            setLoading(true);
            try {
                const user = await Auth.currentAuthenticatedUser();
                console.log("formInputs.allow_custom_product :: " + formInputs.allow_custom_product);
                const input = {
                    name: formInputs.name,
                    type: formInputs.type,
                    age: formInputs.age,
                    anual_revenue: formInputs.anual_revenue,
                    region: formInputs.region,
                    featured_category: formInputs.featured_category != null && formInputs.featured_category.length == 2 ? formInputs.featured_category[0] + '|' + formInputs.featured_category[1] : [],
                    additional_titles1: formInputs.additional_titles1,
                    additional_titles2: formInputs.additional_titles2,
                    additional_titles3: formInputs.additional_titles3,
                    additional_titles4: formInputs.additional_titles4,
                    description: formInputs.description,
                    main_market: formInputs.main_market,
                    allow_custom_product: formInputs.allow_custom_product == true ? 1 : 0,
                    //cover_picture: file1,
                    //company_logo: file2,
                    titles: formInputs.titles,
                    production_lines_qty: formInputs.production_lines_qty,
                    employees_qty: formInputs.employees_qty,
                    address_str: formInputs.address_str,
                    address: {
                        street: formInputs.street,
                        city: formInputs.city,
                        zipCode: formInputs.zipCode,
                        state: formInputs.state,
                        country: formInputs.country,
                        phone: formInputs.phone
                    },
                    hidden: 0,
                    website: formInputs.website,
                    address_line2: formInputs.street2,

                    promote1: formInputs.promote1,
                    promote2: formInputs.promote2,
                    promote3: formInputs.promote3,
                    process1: formInputs.process1,
                    process2: formInputs.process2,
                    process3: formInputs.process3,
                    about_market1: formInputs.about_market1,
                    about_market2: formInputs.about_market2,
                    about_market3: formInputs.about_market3,
                    about_market4: formInputs.about_market4,
                    about_market5: formInputs.about_market5,
                    published: 0,
                };
                const result = await API.graphql(
                    graphqlOperation(createCompany, { input })
                );
                console.log("Created company", result);

                await companyLambdaInvokes.saveCompany({
                    id: result.data.createCompany.id,
                    owner: result.data.createCompany.owner,
                    name: formInputs.name,
                    logoA: '',
                    logoB: '',
                    logoC: '',
                    currentUser: user.username
                });

                setLoading(false);
                history.push("/my-store-wizard-ng/" + result.data.createCompany.id + "/2");
                setCurrentStep(2);
                window.scrollTo({ top: 0, behavior: 'smooth' });

            } catch (e) {
                console.error(e)
                setLoading(false);
                if (e === 'The user is not authenticated') {
                    history.push("/");
                }
            }
        }
    }


    const handleSaveMyStore = () => {
        console.log('handleSaveMyStore');
        saveMyStore();
        /*form2.current.validate((valid) => {
            console.log('validator step2 :: ' + valid);
            if (!valid) {
                return;
            } else {
                saveMyStore();
            }
        });*/

    }

    const fillYearsOptions = () => {
        console.log("fillYearsOptions");
        let currentYear = new Date().getFullYear();
        console.log("currentYear :: " + currentYear);
        let options = [];
        console.log("currentYear <= 1950 :: " + (parseInt(currentYear) >= 1950));
        for (let i = parseInt(currentYear); i >= 1950; i--) {
            let option = {
                label: i,
                value: i
            }
            options.push(option);
        }
        //yearOptions.options = options;
        setYearOptions({ options: options });
        console.log({ yearOptions });
    }

    const loadSubCategories = async (value) => {
        console.log('loadSubCategories ==> ' + value[0]);
        console.log('loadSubCategories ==> ' + value[1]);
        setFormInputs({ ...formInputs, featured_category: value })

    }

    const handleFinish = () => {
        setTimeout(function () {
            Notification({
                title: t('my-store.create.form.success-title'),
                message: t('my-store.create.form.success-msg'),
                type: 'success'
            });
            history.push("/my-store/f");
        }, 300);
    }

    return (
        <div>
            {
                loading && <Loading fullscreen={loading} />
            }

            {
                iaModalDialogVisible ?
                    <Dialog size="large" title="Company Description Language" visible={iaModalDialogVisible} onCancel={() => setIaModalDialogVisible(false)}>
                        <Dialog.Body>
                            <h3>Detectamos que la Descripci&oacute;n de Empresa esta en espa&ntilde;ol, ¿Deseas usar esta traducci&oacute;n?:</h3>
                            <p className='pb-4'>{formInputs.ia_description}</p>
                            <Button type="primary" onClick={() => { copyIADescriptionToDescription(); setIaModalDialogVisible(false) }}>S&iacute;, copiar traducci&oacute;n</Button>
                            <Button type="secondary" onClick={() => setIaModalDialogVisible(false)}>No copiar</Button>
                        </Dialog.Body>
                    </Dialog>

                    : <></>
            }

            {
                imageDialogVisible ? <MyStoreCropImage
                    modalSize="small"
                    visible={imageDialogVisible}
                    setLoadingParent={setLoading}
                    onCancelDialogCallback={() => {
                        console.log("onCancelDialogCallback callback!");
                        setImageDialogVisible(false);
                    }}
                    onSaveImageCallback={(companyPageUpdated) => {
                        console.log("onSaveImageCallback callback!");
                        setImageDialogVisible(false);
                        if (fieldToUpdate === 'cover_picture') {
                            setFormInputs({ ...formInputs, cover_picture: companyPageUpdated.cover_picture });
                        }
                        if (fieldToUpdate === 'company_logo') {
                            setFormInputs({ ...formInputs, company_logo: companyPageUpdated.company_logo });
                        }
                    }}
                    fieldToUpdate={fieldToUpdate}
                    s3KeyPrefix={`/${formInputs.name}/${fieldToUpdate}`}
                    companyPageId={id}
                /> : <></>
            }
            <div>

                <div className="my-store-wizard-div">
                    {
                        currentStep === -1 ?
                            <WizardNgStepMinus1 form={formMinus1} rules={rulesMinus1} formInputs={formInputs}
                                handleNextStep={nextStep} step={currentStep} setFormInputs={setFormInputs} />
                            :
                            <></>
                    }

                    {
                        currentStep === 0 ?
                            <WizardNgStep0 handleNextStep={nextStep} step={currentStep}
                                form0={form0} formInputs={formInputs} setFormInputs={setFormInputs} rules0={rules0} t={t}
                                type={type} yearOptions={yearOptions} revenue={revenue} countryOptions={countryOptions}
                                handlePrevStep={prevStep} idenfityDescriptionLanguage={idenfityDescriptionLanguage}

                            />
                            :
                            <></>
                    }

                    {
                        currentStep === 1 ?
                            <WizardNgStep1 handleNextStep={nextStep} step={currentStep}
                                form1={form1} formInputs={formInputs} setFormInputs={setFormInputs} rules1={rules1} t={t}
                                main_market={main_market} handlePrevStep={prevStep} tooltopImage={tooltopImage} options2={options2}
                                loadSubCategories={loadSubCategories} handleSaveMyStore={handleSaveMyStore}
                            />
                            :
                            <></>
                    }

                    {
                        currentStep === 2 ?
                            <WizardNgStep2 handleNextStep={nextStep} step={currentStep}
                                form2={form2} formInputs={formInputs} setFormInputs={setFormInputs} rules2={rules2} t={t}
                                handleFinish={handleFinish}
                                handlePrevStep={prevStep} handleSaveMyStore={handleSaveMyStore} editCompanyImage={editCompanyImage}
                            />
                            :
                            <></>
                    }

                </div>

            </div>
        </div>
    )
}

export default MyStoreWizard;